import React, { useEffect, useState } from "react";
import {
  Button,
  Heading,
  Loader,
  ScrollView,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  View,
  Icon,
  Alert,
  SelectField,
  Accordion,
  CheckboxField,
  useAuthenticator
} from "@aws-amplify/ui-react";
import "./Badanti.css";
import { Modal } from "react-bootstrap";
import { MdBlock, MdEdit, MdLock, MdLockOpen } from "react-icons/md";
import { blockUserAPI, getBadantiBozzeListAPI, unblockUserAPI } from "../../data/api";
import { getUserRoleLabel } from "../../data/interfaces";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { BsSortDown, BsSortUp } from "react-icons/bs";
import { badantiAttributes, bozzeColumns, formatValue, getLabel } from "./config";
import CreateBadanteBozzaForm from "./CreateBadanteBozzaForm";
import CreateUserForm from "../users/CreateUserForm";


const BadantiTable = (props) => {
  return (
    <Table caption="" highlightOnHover={true}>
        <TableHead>
        <TableRow>
            {
            props.columns.map(c => 
                <TableCell as="th" key={c}>
                <Icon 
                    as={props.order === 'asc' ? BsSortUp : BsSortDown} 
                    style={{fontSize: "24", marginTop: "7px"}}
                    color={props.sortKey === c ? '#000000' : '#d3d3d3'}
                    onClick={() => props.onUpdateOrder(c)}
                ></Icon>
                {getLabel(c) ?? '-'}
                </TableCell>
            )
            }
        </TableRow>
        </TableHead>
        <TableBody>
            {props.badanti?.map((item) => { return (
            <TableRow 
                key={item.ID}
                onClick={() => props.onClickBadante(item.ID)} 
                style={{"cursor":"pointer"}}
            >
                {
                props.columns.map(c => { return (
                    <TableCell>{formatValue(item[c], c)}</TableCell>
                ) })
                }
            </TableRow>)
            })}
        </TableBody>
    </Table>
  );
};

export default BadantiTable;
